export default class HeroStoryList{
    constructor({ stories = [], clickHandler }){
        this.stories = stories;
        this.onClick = clickHandler;
    }

    render(container){

        container.innerHTML = '';

        if (this.stories.length === 0){
            container.innerHTML = `
                <div>
                    <h2>Сюжеты отсутсвуют</h2>
                </div>
            `;
            return;
        }

        container.innerHTML = `
            <div class="page-header-title">
                <h2>Выбрать сюжет</h2>
            </div>
        `;

        const storyGrid = document.createElement('div');
        storyGrid.className = 'story-list';

        this.stories.forEach(story =>{
            const storyElement = this.createStoryElement(story);
            storyGrid.appendChild(storyElement);
        })

        container.appendChild(storyGrid);
    }

    createStoryElement(story){
        const element = document.createElement('div');
        element.className = 'story-item';
        element.setAttribute('data-id', story.id);
        element.innerHTML = `
            <h3>${story.name}</h3>
            <span>${story.description}</span>
        `;
        this.bindEvent(element, story)
        return element;
    }

    bindEvent(element, story){
        element.addEventListener('click', async () =>{
            this.onClick(story.id);
        })
    }
}